import fromPairs from 'lodash/fromPairs';
// $FlowFixMe[untyped-import]
import { createReducer } from 'redux-act';
import { computeDefaultTemplateLabel } from './actions';
import { defaultTemplateResource } from './resource';
const fetchOneSuccessHandler = (state, payload, meta) => ({
  ...state,
  // $FlowFixMe[prop-missing]
  // $FlowFixMe[incompatible-use]
  [meta.label]: payload.response.data.id
});
const deleteOneSuccessHandler = (state, payload, meta) => ({
  ...state,
  [meta.label]: undefined
});
const getProductProcess = action => {
  const [productType, process] = action.split('_');

  // $FlowFixMe[unclear-type]
  return [productType, process];
};
const fetchSuccessHandler = (state, payload) => {
  // $FlowFixMe[incompatible-use]
  const sharingId = payload.params.sharing_id;
  const defaults = fromPairs(
  // $FlowFixMe[not-a-function]
  // $FlowFixMe[prop-missing]
  // $FlowFixMe[incompatible-use]
  // $FlowFixMe[missing-local-annot]
  payload.response.data.map(({
    action,
    template
  }) => {
    const [productType, process] = getProductProcess(action);
    const label = computeDefaultTemplateLabel(productType, process,
    // $FlowFixMe[incompatible-call]
    sharingId);
    return [label, template.id];
  }));
  return {
    ...state,
    ...defaults
  };
};
const initialState = {};
export default createReducer({
  [defaultTemplateResource.fetchOne.success.toString()]: fetchOneSuccessHandler,
  [defaultTemplateResource.deleteOne.success.toString()]: deleteOneSuccessHandler,
  [defaultTemplateResource.fetch.success.toString()]: fetchSuccessHandler
}, initialState
// $FlowFixMe[unclear-type]
);